'use strict';

// Setting up jQuery plugins Keep for hoverintent
var $ = require('jquery');
//@ts-ignore
window.jQuery = $;
require('hoverintent-jqplugin')($);

import "./component/Analytics";

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
require('./lib/jsfAjaxEvents.js');

// Components
var Forms = require('./lib/Forms.js');
var MobileMenu = require('./site/MobileMenu.js');
var Gallery = require('./site/Gallery.js');
var Carousel = require('./site/Carousel.js');
var PeopleGroup = require('./site/PeopleGroup.js');
var TabbedArea = require('./site/TabbedArea.js');
var Newsroom = require('./site/Newsroom.js');
var AccessibleDropdown = require('./site/AccessibleDropdown.js');
var Accordion = require('./site/Accordion.js');
var ScrollCheck = require('./site/ScrollCheck.js');
var GeneralMap = require('./site/GeneralMap.js');
var mastheadParallax = require('./site/parallax.js');
var Masthead = require('./site/Masthead.js');

/* ========================================================
 * 		Component Setup
 ========================================================= */
Forms.init();
MobileMenu.init();
Gallery.init();
Carousel.init();
PeopleGroup.init();
TabbedArea.init();
Newsroom.init();
mastheadParallax.init();
AccessibleDropdown.init('.moreFilters', 'active', 'mobile', '.moreFiltersLink');
Accordion.init('.moreFilters', '.moreFiltersLink', 'active', 'desktop');
ScrollCheck.init('body', 'desktop');
GeneralMap.init('.contact__map', '.adr');
GeneralMap.init('.property__map', '.adr');
Masthead.init();


/* ========================================================
 * 		Property Search
 ========================================================= */
//@ts-ignore
window.propertyMap = require('./site/PropertyMap.js')();

import AutoCompleter from './component/AutoCompleter';
AutoCompleter();

/* ========================================================
 * 		Imports
 ========================================================= */
import entryVideo from './component/entryVideo';
entryVideo('.masthead__videoWrap');

/* ========================================================
 * 		Video Lightbox
 ========================================================= */
import VideoLightbox from './component/VideoLightbox';
VideoLightbox();

/* ========================================================
 * 	    Kiosk Landing Page
 ========================================================= */
import './component/KioskLandingPage/kioskLandingPage';
